<ion-content [scrollY]="false">
  <ion-split-pane when="md" contentId="storyMain">
    <ion-menu contentId="storyMain" class="story-sidebar">
      <ion-content class="story-sidebar__scroll re-menu-surface">
        <header class="story-sidebar__header" [class.story-sidebar__header--ai]="story.data()?.ai_mode === 'AI'">
          <div class="story-sidebar__orb" aria-hidden="true"></div>
          <div class="story-sidebar__header-top">
            <div class="story-sidebar__badges">
              <span class="story-sidebar__badge">{{ 'common.campaign' | translate }}</span>
              @if (story.data()?.ai_mode === 'AI') {
              <span class="story-sidebar__badge story-sidebar__badge--ai">
                <ion-icon name="sparkles" aria-hidden="true"></ion-icon>
                {{ 'stories.home.aiMaster' | translate }}
              </span>
              }
            </div>
            <ion-button class="story-sidebar__settings" routerLink="./settings" fill="clear" size="small"
              [attr.aria-label]="'stories.settings.title' | translate">
              <ion-icon slot="icon-only" name="settings-outline"></ion-icon>
            </ion-button>
          </div>
          <p class="story-sidebar__title">{{ story.data()?.name }}</p>
          <div class="story-sidebar__divider" aria-hidden="true"></div>
        </header>

        <section class="story-sidebar__section">
          <div class="story-sidebar__section-head">
            <p class="story-sidebar__label">{{ 'common.activeRooms' | translate }}</p>
            @if (showCreateChat() && story.data()?.ai_mode !== 'AI') {
            <ion-button class="story-sidebar__add-room" routerLink="create-chat" fill="clear" size="small"
              [attr.aria-label]="'stories.createChat.title' | translate">
              <ion-icon slot="icon-only" name="add"></ion-icon>
            </ion-button>
            }
          </div>
          <re-chats-list [compact]="true" style="--card-margin: 0px" [chats]="story.chats()"></re-chats-list>
        </section>

        <section class="story-sidebar__section">
          <p class="story-sidebar__label">{{ 'common.quickAccess' | translate }}</p>
          <nav class="story-sidebar__nav">
            @if (story.data()?.ai_mode === 'AI') {
            <a class="story-sidebar__nav-item" routerLink="./rules" routerLinkActive="active">
              <span class="story-sidebar__nav-icon story-sidebar__nav-icon--ai">
                <ion-icon name="book-outline" aria-hidden="true"></ion-icon>
              </span>
              <span class="story-sidebar__nav-text">
                <span class="story-sidebar__nav-title">{{ 'stories.home.rulesTitle' | translate }}</span>
                <span class="story-sidebar__nav-desc">{{ 'stories.home.rulesDesc' | translate }}</span>
              </span>
            </a>
            } @else {
            <a class="story-sidebar__nav-item" routerLink="./operations" routerLinkActive="active">
              <span class="story-sidebar__nav-icon story-sidebar__nav-icon--bronze">
                <ion-icon name="flash-outline" aria-hidden="true"></ion-icon>
              </span>
              <span class="story-sidebar__nav-text">
                <span class="story-sidebar__nav-title">{{ 'stories.home.operationsTitle' | translate }}</span>
                <span class="story-sidebar__nav-desc">{{ 'stories.home.operationsDesc' | translate }}</span>
              </span>
            </a>
            }

            <a class="story-sidebar__nav-item" routerLink="./characters" routerLinkActive="active">
              <span class="story-sidebar__nav-icon story-sidebar__nav-icon--amber">
                <ion-icon name="people-outline" aria-hidden="true"></ion-icon>
              </span>
              <span class="story-sidebar__nav-text">
                <span class="story-sidebar__nav-title">{{ 'stories.home.charactersTitle' | translate }}</span>
                <span class="story-sidebar__nav-desc">{{ 'stories.home.charactersDesc' | translate }}</span>
              </span>
            </a>

            <a class="story-sidebar__nav-item" routerLink="./diary" routerLinkActive="active">
              <span class="story-sidebar__nav-icon story-sidebar__nav-icon--bronze">
                <ion-icon name="book-outline" aria-hidden="true"></ion-icon>
              </span>
              <span class="story-sidebar__nav-text">
                <span class="story-sidebar__nav-title">{{ 'stories.home.diaryTitle' | translate }}</span>
                <span class="story-sidebar__nav-desc">{{ 'stories.home.diaryDesc' | translate }}</span>
              </span>
            </a>
          </nav>
        </section>

        <footer class="story-sidebar__footer">
          <a class="story-sidebar__home" routerLink="/" [replaceUrl]="true">
            <ion-icon name="home-outline" aria-hidden="true"></ion-icon>
            {{ 'common.home' | translate }}
          </a>
        </footer>
      </ion-content>
    </ion-menu>
    <div id="storyMain" class="ion-page">
      <ion-router-outlet></ion-router-outlet>
    </div>
  </ion-split-pane>
</ion-content>
